import { gql } from '@apollo/client';

export const GET_FEATURE_FLAGS = gql`
  query FeatureFlagsByCompany($companyId: ID!) {
    featureFlagsByCompany(companyId: $companyId) {
      featureName
      enabled
      id
    }
  }
`;

export const GET_ALL_FEATURE_FLAGS = gql`
  query FeatureFlags {
    allFeatureFlags {
      id,
      featureName: name,
    }
  }
`;
